import { ModuleRegistry } from "seneca-common/features/module/registry";

import { markAnswer } from "./logic/answers";
import { generateContent } from "./logic/content";

export const MODULE_TYPE = "toggles";
export type TYPE = "toggles";

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .back.staticInformation()
    .displayName("Toggles")
    .testOnly()
    .root.register();
